import React from "react";
import { api } from "../../utils/Api";
import Home from "../Home/Home";

function DisabledAccount(props: any) {
  async function enable() {
    let pass_data = {
      post: "",
    };

    const response = await api("/users/enable_account", pass_data);
    console.log("enable response :", response);

    if (response.status_code == 200) {
      window.location.href = "/";
    }
  }
  return (
    <div>
      <p>Your account is Disabled</p>
      <br></br>
      <p>
        Enable it :
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            enable();
          }}
        >
          Enable
        </button>
      </p>
    </div>
  );
}

export default DisabledAccount;
